import styled from '@emotion/styled';
import { TimerVariant } from '@/common/countdownTimer/CountdownTimer';

export const TimerBannerText = styled.div<{ $variant?: TimerVariant }>`
    flex: 1 0 50%;
    width: 50%;
    padding: 8px 16px;
    background: #E21216 linear-gradient(to left, #AF0003, transparent);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    font-size: 14px;
    position: relative;
    clip-path: polygon(0 0, 90% 0, 100% 50%, 90% 100%, 0 100%);
    letter-spacing: 1px;
    white-space: nowrap;
    font-family: 'open_sans_semi', sans-serif;
    margin-right: -15px;

    ${props => props.$variant === 'deals' && `
      @media (max-width: 1024px) and (min-width: 951px) {
       margin-right: -10px;
      }
      @media (max-width: 950px) {
        width: 100%;
        flex: none;
        clip-path: none;
        padding: 6px 12px;
        height: 24px;
        margin-right: 0;
      }
      @media (max-width: 710px) {
        font-size: 12px;   
      }
  `}

    ${props => props.$variant === 'sidekicks' && `
      @media (max-width: 900px) and (min-width: 651px){
        width: 100%;
        flex: none;
        clip-path: none;
        padding: 6px 12px;
        height: 24px;
        margin-right: 0px;
      }
      @media (max-width: 650px) {
        margin-right: -20px;   
      }
  `}
`;
